import { render, staticRenderFns } from "./SececondaryTrustees.vue?vue&type=template&id=1965db96"
import script from "./SececondaryTrustees.vue?vue&type=script&lang=js"
export * from "./SececondaryTrustees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports